import { render, staticRenderFns } from "./BjKanban.vue?vue&type=template&id=798923d6"
import script from "./BjKanban.vue?vue&type=script&lang=js"
export * from "./BjKanban.vue?vue&type=script&lang=js"
import style0 from "./BjKanban.vue?vue&type=style&index=0&id=798923d6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports